import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf2c5ec2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-report align-stretch" }
const _hoisted_2 = { class: "slide-report-text flex-grow" }
const _hoisted_3 = { class: "observations_header" }
const _hoisted_4 = {
  key: 0,
  class: "observations"
}
const _hoisted_5 = { class: "observation_title" }
const _hoisted_6 = { class: "observation_value" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "observation_value"
}
const _hoisted_9 = {
  key: 1,
  class: "comments"
}
const _hoisted_10 = { class: "heading" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = {
  key: 2,
  class: "no_observations"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlidePreview = _resolveComponent("SlidePreview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.slide.slideId), 1),
      (_ctx.observations.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.observations, (observation, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "observation",
                key: index
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t(`config.insight.slide.${_ctx.activeCase.tissue}.${_ctx.slide.stain}.${observation.key}.title`)), 1),
                _createTextVNode(" : "),
                (Array.isArray(observation.value))
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(observation.value, (value, i) => {
                      return (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        (i !== 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, ", "))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(value), 1)
                      ]))
                    }), 256))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(observation.value), 1))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.comments?.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t("reports.comments_title")) + ":", 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.comments.value), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.observations.length && !_ctx.comments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.t("reports.no_observations")), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_SlidePreview, {
      class: "case-report",
      slide: _ctx.slide,
      onSelectFromSlide: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectSlide($event)))
    }, null, 8, ["slide"])
  ]))
}